var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"animated fadeIn"},[(_vm.sameAvg && _vm.avg)?_c('div',[_c('b-badge',{attrs:{"variant":_vm.getVariant()}},[_vm._v(" "+_vm._s(_vm.avg)+"/"+_vm._s(Math.abs(_vm.sameAvg - _vm.avg).toFixed(2))+" ")])],1):_c('div',[_c('b-badge',{attrs:{"variant":"default"}},[_vm._v(" Данных нет ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }